import { EChartType, TDealType } from '../../../types/charts';

export function getLabelText(dealType: TDealType, chartType: EChartType) {
  switch (chartType) {
    case EChartType.Price:
      return getPriceText(dealType);
    case EChartType.OffersCount:
      return 'Количество объявлений';
    case EChartType.OffersViewed:
      return 'Количество просмотров';
    case EChartType.Mortgage:
      return 'Процентная ставка';
  }
}

export function getPriceText(dealType: TDealType) {
  switch (dealType) {
    case 'sale':
      return 'Средняя цена';
    case 'rent':
    case 'rentDay':
      return 'Арендная ставка';
  }
}
